<template>
  <div class="main">
    <div class="h1" style="font-size: 24px;">{{data.title}}</div>
    <!-- <div class="h2">
      个性特征描述：
    </div>
    <div v-html="data.personality_description"></div>
    <div class="h2">
      可能存在的盲点：
    </div>
    <div v-html="data.possible_blind_spots"></div>
    <div class="h2">
      功能运用：
    </div>
    <div v-html="data.function_use"></div>
    <div class="h2">
      问题解决方式：
    </div>
    <div v-html="data.problem_solving_method"></div>
    <div class="h2">
      工作中的优势：
    </div>
    <div v-html="data.job_advantage"></div>
    <div class="h2">
      工作中的劣势：
    </div>
    <div v-html="data.job_disadvantage"></div>
    <div class="h2">
      适合的岗位特质：
    </div>
    <div v-html="data.suitable_job_characteristics"></div>
    <div class="h2">
      职业类型--您适合的职位：
    </div>
    <div v-html="data.type_of_jobs"></div>
    <div class="h2">
      对组织的贡献：
    </div>
    <div v-html="data.contribution_to_the_organization"></div>
    <div class="h2">
      领导风格：
    </div>
    <div v-html="data.leadership_style"></div>
    <div class="h2">
      潜在缺陷：
    </div>
    <div v-html="data.latent_defect"></div>
    <div class="h2">
      适合的工作环境：
    </div>
    <div v-html="data.suitable_working_environment"></div>
    <div class="h2">
      个人发展建议：
    </div>
    <div v-html="data.personal_development_advice"></div> -->
    <div v-html="data.content" style="line-height: 40px;"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: []
      }
    },
    created() {
      let result = this.$route.query.result.split(",");
      this.$http.testMbtiResult({
        result: result
      }).then(res => {
        this.data = res.data
      })
    }
  }
</script>

<style scoped>
  .main {
    width: 1280px;
    margin: 20px auto;
    justify-content: space-around;
    text-align: left !important;
  }

  .h2 {
    font-weight: bold;
    font-size: 18px;
    margin: 25px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/test/testResult.vue